import ModelEntity from "../../model2/model-entity"
import {EntityType} from "../../gd/const/item"
import DatetimeUtils from "../../gd/utils/datetime-utils"

export default class RecentTaskModel extends ModelEntity {
    public taskId   : ID
    public date     : Moment

    public title: string
    public taskTypeId: ID
    public projectId: ID
    public companyId: ID
    public actionRequiredUserId: ID
    public systemStatus: number

    constructor(data:any) {
        super(data.taskId, EntityType.RECENT_TASK)

        this.taskId                 = data.taskId
        this.date                   = DatetimeUtils.datetimeToMoment(data.date)
        this.title                  = data.title
        this.taskTypeId             = data.taskTypeId
        this.projectId              = data.projectId
        this.companyId              = data.companyId
        this.actionRequiredUserId   = data.actionRequiredUserId
        this.systemStatus           = data.systemStatus
    }

    setData(data:any){
        if (data.title)                 this.title                  = data.title
        if (data.taskTypeId)            this.taskTypeId             = data.taskTypeId
        if (data.projectId)             this.projectId              = data.projectId
        if (data.companyId)             this.companyId              = data.companyId
        if (data.actionRequiredUserId)  this.actionRequiredUserId   = data.actionRequiredUserId
        if (data.systemStatus)          this.systemStatus           = data.systemStatus
    }

    getTask(){
        return {
            id                  : this.taskId,
            date                : this.date,
            title               : this.title,
            taskTypeId          : this.taskTypeId,
            projectId           : this.projectId,
            companyId           : this.companyId,
            actionRequiredUserId: this.actionRequiredUserId,
            systemStatus        : this.systemStatus
        }
    }

    localStorageFormat() {
        return '{0}-{1}'.f(this.taskId, this.date.format('X'))
    }
}